<app-splash-screen></app-splash-screen>

<body id="kt_body" class="print-content-only header-fixed subheader-enabled">
  <!--<app-mobileheader></app-mobileheader>-->
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="d-flex flex-row flex-column-fluid page">
      <!--begin::Wrapper-->
      <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
        <!--begin::Header-->
        <app-header></app-header>
        <!--end::Header-->
        <!--begin::Content-->
        <router-outlet *ngIf="!isIframe"></router-outlet>
        <!--end::Content-->
        <!--begin::Header-->
        <app-footer></app-footer>
        <!--end::Header-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</body>
<app-chatbot></app-chatbot>